import React from 'react';

import './FeeDetail.scss';

import { TripReceipt } from 'types/trip';

interface FeeDetailProps {
  receipt: TripReceipt;
  isCancel: boolean;
}

export const FeeDetail: React.FC<FeeDetailProps> = ({ receipt, isCancel }) => {
  return (
    <div className="history-detail-block history-fee-detail">
      <p className="history-detail-block__title">費用詳情</p>
      <div className="history-detail-block__content">
        <div className="history-fee-detail__item">
          <p>小計：</p>
          <p>${receipt.fare}</p>
        </div>
        {isCancel && (
          <div className="history-fee-detail__item">
            <p>取消費用：</p>
            <p>${receipt.cancelFare}</p>
          </div>
        )}
        <div className="history-fee-detail__item">
          <p>優惠折抵：</p>
          <p>-${receipt.discountAmount}</p>
        </div>
        <div className="history-fee-detail__item">
          <p>紅利：</p>
          <p>-${receipt.bonusAmount}</p>
        </div>
      </div>
      <div className="history-fee-detail__footer">
        <div className="history-fee-detail__item">
          <p className="history-fee-detail__item__title">行程費用</p>
          <p>${receipt.balance}</p>
        </div>
      </div>
    </div>
  );
};
